var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 25,
    rx: 3,
    fill: "#B7C5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8556 5.00234C16.7729 5.01154 16.6956 5.04919 16.6362 5.10918L7.03124 14.986C6.98238 15.0367 6.94838 15.1004 6.93312 15.17L6.00956 19.3487C5.99547 19.4111 5.99698 19.4762 6.01393 19.5379C6.03088 19.5996 6.06273 19.6558 6.10651 19.7014C6.15029 19.747 6.20459 19.7805 6.26434 19.7988C6.32409 19.817 6.38736 19.8194 6.44825 19.8057L10.5119 18.856C10.5796 18.8403 10.6416 18.8054 10.6908 18.7551L20.2958 8.87829C20.3306 8.84296 20.3581 8.8009 20.3769 8.75454C20.3958 8.70818 20.4054 8.65845 20.4054 8.60822C20.4054 8.55799 20.3958 8.50825 20.3769 8.4619C20.3581 8.41554 20.3306 8.37348 20.2958 8.33815L17.1557 5.10918C17.1166 5.06954 17.0693 5.03938 17.0174 5.0209C16.9655 5.00242 16.9102 4.99608 16.8556 5.00234ZM16.896 5.91642L19.5166 8.61119L18.189 9.97044L15.5684 7.28161L16.896 5.91642ZM15.0489 7.81582L17.6695 10.5106L10.4311 17.9479L7.8105 15.2591L15.0489 7.81582ZM7.50457 16.0129L9.69802 18.2684L6.85808 18.9332L7.50457 16.0129Z",
    fill: "#041760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3ea4c3a39d279fbbfce4992396427c0a.svg";
export { ForwardRef as ReactComponent };